module.exports = __webpack_public_path__ + "static/cc-1-5a904ac35236bdcf1d9ffa1ff86a47b4.jpg";